import Country from '../models/Country'
const state = {
  countries: [],
};

const mutations = {
  'SET_COUNTRIES'(state, countries) {
    state.countries = countries
  },
};

const actions = {
  async set_countries({commit}) {
    try {
      let countries = await Country.all(`sort=name%7Casc&page=1&per_page=999&filter=`)
      commit('SET_COUNTRIES', countries.data)
      return countries.data
    } catch (e) {
      return e
    }
  },
}

const getters = {
  countries: state => {
    return state.countries
  },
  real_countries: state => {
    return state.countries.filter(country => !country.is_for_secondary_currency)
  },
  id_valid_countries: state => {
    return state.countries.filter(country => !country.is_for_secondary_currency && country.has_acceptable_id_document)
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
